// @flow
import { CommonMapper } from 'mappers/common';
import { ArchitectsActionTypes } from 'modules/shibaniKamalArchitecture/actionTypes';
import { ProjectMapper } from 'mappers/project';

const getGalleryForArchitecture = () => (dispatch, getState, { api }) => {
  dispatch({
    type: ArchitectsActionTypes.GALLERY.FETCH,
    payload: {},
    test: api
      .post(`galleries.json`, {
        model: 'Shibanee & Kamal',
      })
      .then(res => {
        const response = res.data.data || {};
        const galleryImages = response.galleries || [];
        const mediaPath = CommonMapper.extractMediaPath(response);

        dispatch({
          type: ArchitectsActionTypes.GALLERY.SUCCESS,
          payload: CommonMapper.mapGalleryImages(galleryImages, mediaPath),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: ArchitectsActionTypes.GALLERY.FAILURE,
          error,
        });
      }),
  });
};

const getProjectDetailsForArchitecture = () => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: ArchitectsActionTypes.PROJECT_OVERLAY.FETCH,
    payload: {},
    test: api
      .post(`getImagesForProjectOverlay.json`)
      .then(res => {
        const response = res.data.data || {};
        const data = response.overlay || [];
        const mediaPath = CommonMapper.extractMediaPath(response);

        dispatch({
          type: ArchitectsActionTypes.PROJECT_OVERLAY.SUCCESS,
          payload: ProjectMapper.mapProjectsForOverlay(data, mediaPath),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: ArchitectsActionTypes.PROJECT_OVERLAY.FAILURE,
          error,
        });
      }),
  });
};

export const ArchitectsActions = {
  getGalleryForArchitecture,
  getProjectDetailsForArchitecture,
};
